"use strict";
/// <reference lib="es2017" />
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebClientEvent = exports.WebClient = exports.ChatStreamer = exports.retryPolicies = exports.LogLevel = exports.addAppMetadata = exports.WebAPIRequestError = exports.WebAPIRateLimitedError = exports.WebAPIPlatformError = exports.WebAPIHTTPError = exports.WebAPIFileUploadReadFileDataError = exports.WebAPIFileUploadInvalidArgumentsError = exports.SlackError = exports.ErrorCode = void 0;
var errors_1 = require("./errors");
Object.defineProperty(exports, "ErrorCode", { enumerable: true, get: function () { return errors_1.ErrorCode; } });
Object.defineProperty(exports, "SlackError", { enumerable: true, get: function () { return errors_1.SlackError; } });
Object.defineProperty(exports, "WebAPIFileUploadInvalidArgumentsError", { enumerable: true, get: function () { return errors_1.WebAPIFileUploadInvalidArgumentsError; } });
Object.defineProperty(exports, "WebAPIFileUploadReadFileDataError", { enumerable: true, get: function () { return errors_1.WebAPIFileUploadReadFileDataError; } });
Object.defineProperty(exports, "WebAPIHTTPError", { enumerable: true, get: function () { return errors_1.WebAPIHTTPError; } });
Object.defineProperty(exports, "WebAPIPlatformError", { enumerable: true, get: function () { return errors_1.WebAPIPlatformError; } });
Object.defineProperty(exports, "WebAPIRateLimitedError", { enumerable: true, get: function () { return errors_1.WebAPIRateLimitedError; } });
Object.defineProperty(exports, "WebAPIRequestError", { enumerable: true, get: function () { return errors_1.WebAPIRequestError; } });
var instrument_1 = require("./instrument");
Object.defineProperty(exports, "addAppMetadata", { enumerable: true, get: function () { return instrument_1.addAppMetadata; } });
var logger_1 = require("./logger");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return logger_1.LogLevel; } });
var retry_policies_1 = require("./retry-policies");
Object.defineProperty(exports, "retryPolicies", { enumerable: true, get: function () { return __importDefault(retry_policies_1).default; } });
__exportStar(require("./types/request/index"), exports);
__exportStar(require("./types/response/index"), exports);
var chat_stream_1 = require("./chat-stream");
Object.defineProperty(exports, "ChatStreamer", { enumerable: true, get: function () { return chat_stream_1.ChatStreamer; } });
var WebClient_1 = require("./WebClient");
Object.defineProperty(exports, "WebClient", { enumerable: true, get: function () { return WebClient_1.WebClient; } });
Object.defineProperty(exports, "WebClientEvent", { enumerable: true, get: function () { return WebClient_1.WebClientEvent; } });
// methods must be exported after WebClient
__exportStar(require("./methods"), exports);
//# sourceMappingURL=index.js.map